export enum Tokens {
  DAI = 'dai',
  MKR = 'mkr',
  IOU = 'iou',
  IOU_OLD = 'iouOld'
}
